var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-wrap flex flex-wrap flex-pack-justify"},[_c('video-player',{staticClass:"vjs-custom-skin videosa",attrs:{"options":_vm.videoConfig}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }